export default "__VITE_ASSET__DUjklMs0__"